import {NgModule} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'
import {DayWorkingTimeModel, GanttModule} from '@syncfusion/ej2-angular-gantt'
import {EditService} from '@syncfusion/ej2-angular-gantt'
import {Component, ViewEncapsulation, OnInit, ViewChild} from '@angular/core';
import {Gantt} from '@syncfusion/ej2-gantt';
import {EditSettingsModel} from '@syncfusion/ej2-angular-gantt';
import {Azienda} from '../models/Azienda';
import {ApiPathsService} from "../../api-paths.service";
import { GanttComponent, ToolbarItem, SelectionSettingsModel } from '@syncfusion/ej2-angular-gantt';
import { ToolbarService, PdfExportService,SelectionService } from '@syncfusion/ej2-angular-gantt';
import { ClickEventArgs } from '@syncfusion/ej2-navigations/src/toolbar/toolbar';
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";
import {DatePipe} from "@angular/common";
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TaskService } from 'src/app/task/_service/task.service';
import { DownloadService } from 'src/app/shared/_services/download.service';

@Component({
  templateUrl: 'registro-presenze.component.html',
  styleUrls: ['./registro-presenze.component.scss'],
  providers: [EditService, ToolbarService, PdfExportService],
})
export class RegistroPresenzeComponent implements OnInit {
  private inputEventSubject: Subject<Event> = new Subject();
  public columns?: object[];
  public data?: object[];
  filtro: any = {};
  legenda: any = {
    area:'Legenda Presenze',
    legenda:[
      {label: 'Presente', color: '#00ff00'},
      {label: 'Assente', color: '#ff0000'},
      {label: 'Dimesso', color: '#000000'},
      {label: 'Assente/Ricovero', color:'#ffa500 '},
      {label: 'Assente/TSO', color:'#ee82ee '},
      {label: 'Assente/Famiglia', color:'#ffff00 '},
      {label: 'Altro', color:'#0000ff '},
    ],
  };
  Clienti: any[];
  dropSetting: IDropdownSettings= { singleSelection: false, singleOutput: false, idField: 'id', textField: 'label',  allowSearchFilter: true, }
  constructor(
    private apiPaths: ApiPathsService,
    private datepipe:DatePipe,
     private TaskService: TaskService,
     private downloadService: DownloadService
    ) {}


  public ngOnInit(): void {
    this.inputEventSubject.pipe(
      debounceTime(500)
    ).subscribe(event => {
      this.handleDebouncedInput(event);
    });
    this.initFilter();
    this.Refresh();
  }
  onInput(event: Event): void {
    this.inputEventSubject.next(event);
  }
  handleDebouncedInput(event: Event): void {
    this.Refresh();
  }

  CreateNewTask(dataInizio, cliente, task){
    return{
      cliente: cliente.id,
      data_inizio_prevista: dataInizio,
      task: task ?? { cliente: cliente.id,clienteObject: cliente, data_inizio_prevista: dataInizio + 'T00:00', data_attivita: dataInizio + 'T00:00', type:'P'},
      id:task?.id
    }
  }
  Refresh(){
    var IntervalloDate = this.TaskService.generateDateArrayEveryXDays( this.filtro.inizio, 1, this.filtro.fine);

    this.apiPaths.ClassicPost('/anagrafica/clienti/list', {page: 0, size: 10, ruolo: 'C', inseriti: true, nome: this.filtro.ospite}).subscribe(data => {
      this.Clienti = data.data;
      this.apiPaths.ClassicPost('/task/task/list', {page: 0, size: 10, tipo: 'P', periodo: this.filtro.inizio && this.filtro.fine ? true :false, inizio: this.filtro.inizio, fine:this.filtro.fine, stati:this.filtro?.selectedTipi?.map(x => x.id)}).subscribe((response: {data:any[], total: number}) => {
        var Presenze = response.data;
        var dummy = IntervalloDate.map(z=> {
          return Presenze.find(y=>y.data_inizio_prevista?.slice(0,10) == z.slice(0,10) ) ?? {data_inizio_prevista: z, Tasks: [...this.Clienti.map(x=>{return this.CreateNewTask(z,x,null)}),]}
        });
        Presenze?.forEach(presenza=>{
          var val = dummy.find(x=>x.data_inizio_prevista?.slice(0,10) == presenza.data_inizio_prevista.slice(0,10))
          if (val) {
            if(!val.Tasks)
              val.Tasks = [...this.Clienti.map(x=>{return this.CreateNewTask(val.data_inizio_prevista,x,null)}),];
            var existing = val.Tasks?.find(x => x.cliente == presenza.cliente);
            if(existing){
              existing.id = presenza.id;
              existing.task = presenza;
            } 
          }
          else {
            var newTask = Object.assign({},presenza)
            newTask.Tasks = [...this.Clienti.filter(x=>x.id != presenza.cliente).map(x=>{return this.CreateNewTask(presenza.data_inizio_prevista,x,null)}), ...[this.CreateNewTask(presenza.data_inizio_prevista,presenza.clienteObject,presenza)]]
            dummy.push(newTask)
          }
        })
        this.columns = dummy;
        console.log("Presenze: ", this.columns)
      });
    });
  }


Stampa(){
  /*
  
  */
  this.apiPaths.FilePost('/anagrafica/clienti/presenza/export',{inizio: this.filtro.inizio, fine:this.filtro.fine, ospite: this.filtro.ospite, stato:this.filtro?.selectedTipi?.map(x => x.id).find(x=> true) }).subscribe((data) => {
    this.downloadService.downloadFile(data);
  }
);
}


  Tooltip(segmento){
    if(segmento?.tipoObject?.id){
                          switch(segmento?.tipoObject?.id){
                              case 187:
                                return 'Assente/Ricovero'
                              break;
                              case 188:
                                return 'Assente/TSO'
                              break;
                              case 189:
                                return 'Assente/Famiglia'
                              break;
                              default:
                                return 'Clicca Qui per inserire una presenza';
                              break;
                          }
                        }else{
                          if(segmento?.statoObject?.id){
                            switch(segmento?.statoObject?.id){
                              case 'P':
                                return 'Presente';
                               
                              break;
                              case 'A':
                                return 'Assente';
                               
                              break;
                              case 'D':
                                return 'Dimesso';
                                
                              break;
                              case 'AL':
                                return 'Altro';
                              
                              break;
                              default:
                                return '';
                              break;
                            }
                          }else{
                            return 'Clicca Qui per inserire una presenza'
                          }
                        }
                        
  }
  BadgeSelect(segmento){
    if(segmento?.tipoObject?.id){
      switch(segmento?.tipoObject?.id){
          case 187:
            segmento.name = 'A/R';
            segmento.iconClass = 'e-round e-partial';
          break;
          case 188:
            segmento.name = 'A/TSO';
            segmento.iconClass = 'e-round e-viola';
          break;
          case 189:
            segmento.name = 'A/F';
            segmento.iconClass = 'e-round e-yellow';
          break;
          default:
            segmento.iconClass = 'e-round e-white';
          break;
      }
    }else{
      if(segmento?.statoObject?.id){
        switch(segmento?.statoObject?.id){
          case 'P':
            segmento.name = 'P';
            segmento.iconClass = 'e-round e-full';
          break;
          case 'A':
            segmento.name = 'A';
            segmento.iconClass = 'e-round e-low';
          break;
          case 'D':
            segmento.name = 'D';
            segmento.iconClass = 'e-round e-black';
          break;
          case 'AL':
            segmento.name = 'AL';
            segmento.iconClass = 'e-round e-blue';
          break;
          default:
            segmento.iconClass = 'e-round e-white';
          break;
        }
      }else{
        segmento.iconClass = 'e-round e-white';
      }
    }
    return segmento.iconClass;
  }
  initFilter(){
    const today = new Date();
    const inizioMese = new Date(today.getFullYear(), today.getMonth(), 1);
    const fineMese = new Date(today.getFullYear(), today.getMonth() + 1, 0) ;
    this.filtro.inizio = this.datepipe.transform( inizioMese,'yyyy-MM-dd');
    this.filtro.fine = this.datepipe.transform( fineMese, 'yyyy-MM-dd');
    this.filtro.tipi =  [{id:'P', label:'Presente'}, {id:'A', label:'Assente'}, {id:'D', label:'Dimesso'}, {id:'AL', label:'Altro'}];
  }



  Click(task){
    console.log("Task Selezionato: ", task)
    this.TaskService.OpenFromTask(task);
  }

}




